<script>
  import { DropdownItem } from 'element-ui'
  export default {
    name:'ElDropdownItem',
    extends:DropdownItem
  }
</script>
